import Highcharts from "highcharts";

window.Highcharts = Highcharts;

import "highcharts/highcharts-more";
import "highcharts/modules/exporting";
import "highcharts/modules/no-data-to-display";
import "highcharts/modules/solid-gauge";
import "vendor/highcharts/redraw-regression";
import "vendor/highcharts/highcharts-overrides";
import "vendor/highcharts/regression";
import "vendor/highcharts/sparkline";
import "highcharts/modules/drilldown";

// import utilities from "highcharts/es-modules/Core/Utilities.js";

import "./highcharts.less";

export default {
	init: function () {
		//turn off Highcharts animation globally
		Highcharts.setOptions({
			plotOptions: {
				series: {
					animation: false,
				},
			},
		});

	// working copy of pure refresh, will be deleted or modified after tests

	// Highcharts.Tooltip.prototype.refresh = function (
	// 	pointOrPoints,
	// 	mouseEvent
	// ) {
	// 	const tooltip = this,
	// 		{ chart, options, pointer, shared } = this,
	// 		points = utilities.splat(pointOrPoints),
	// 		point = points[0],
	// 		formatString = options.format,
	// 		formatter = options.formatter || tooltip.defaultFormatter,
	// 		styledMode = chart.styledMode;
	// 	let wasShared = tooltip.allowShared;
	// 	if (!options.enabled || !point.series) {
	// 		// #16820
	// 		return;
	// 	}
	// 	clearTimeout(this.hideTimer);
	// 	// A switch saying if this specific tooltip configuration allows shared
	// 	// or split modes
	// 	tooltip.allowShared = !(
	// 		!utilities.isArray(pointOrPoints) &&
	// 		pointOrPoints.series &&
	// 		pointOrPoints.series.noSharedTooltip
	// 	);
	// 	wasShared = wasShared && !tooltip.allowShared;
	// 	// Get the reference point coordinates (pie charts use tooltipPos)
	// 	tooltip.followPointer =
	// 		!tooltip.split && point.series.tooltipOptions.followPointer;
	// 	const anchor = tooltip.getAnchor(pointOrPoints, mouseEvent),
	// 		x = anchor[0],
	// 		y = anchor[1];
	// 	// Shared tooltip, array is sent over
	// 	if (shared && tooltip.allowShared) {
	// 		pointer.applyInactiveState(points);
	// 		// Now set hover state for the chosen ones:
	// 		points.forEach((item) => item.setState("hover"));
	// 		point.points = points;
	// 	}
	// 	this.len = points.length; // #6128
	// 	const text = utilities.isString(formatString)
	// 		? utilities.format(formatString, point, chart)
	// 		: formatter.call(point, tooltip);
	// 	// Reset the preliminary circular references
	// 	point.points = void 0;
	// 	// Register the current series
	// 	const currentSeries = point.series;
	// 	this.distance = utilities.pick(currentSeries.tooltipOptions.distance, 16);
	// 	// Update the inner HTML
	// 	if (text === false) {
	// 		this.hide();
	// 	} else {
	// 		// Update text
	// 		if (tooltip.split && tooltip.allowShared) {
	// 			// #13868
	// 			this.renderSplit(text, points);
	// 		} else {
	// 			let checkX = x;
	// 			let checkY = y;
	// 			if (mouseEvent && pointer.isDirectTouch) {
	// 				checkX = mouseEvent.chartX - chart.plotLeft;
	// 				checkY = mouseEvent.chartY - chart.plotTop;
	// 			}
	// 			// #11493, #13095
	// 			if (
	// 				chart.polar ||
	// 				currentSeries.options.clip === false ||
	// 				points.some(
	// 					(
	// 						p // #16004
	// 					) =>
	// 						pointer.isDirectTouch || // ##17929
	// 						p.series.shouldShowTooltip(checkX, checkY)
	// 				)
	// 			) {
	// 				const label = tooltip.getLabel((wasShared && tooltip.tt) || {});
	// 				// Prevent the tooltip from flowing over the chart box
	// 				// (#6659)
	// 				if (!options.style.width || styledMode) {
	// 					label.css({
	// 						width:
	// 							(this.outside ? this.getPlayingField() : chart.spacingBox)
	// 								.width + "px",
	// 					});
	// 				}
	// 				label.attr({
	// 					// Add class before the label BBox calculation (#21035)
	// 					class: tooltip.getClassName(point),
	// 					text: text && text.join ? text.join("") : text,
	// 				});
	// 				// When the length of the label has increased, immediately
	// 				// update the x position to prevent tooltip from flowing
	// 				// outside the viewport during animation (#21371)
	// 				if (this.outside) {
	// 					label.attr({
	// 						x: utilities.clamp(
	// 							label.x || 0,
	// 							0,
	// 							this.getPlayingField().width - (label.width || 0) - 1
	// 						),
	// 					});
	// 				}
	// 				if (!styledMode) {
	// 					label.attr({
	// 						stroke:
	// 							options.borderColor ||
	// 							point.color ||
	// 							currentSeries.color ||
	// 							"#666666" /* Palette.neutralColor60 */,
	// 					});
	// 				}
	// 				tooltip.updatePosition({
	// 					plotX: x,
	// 					plotY: y,
	// 					negative: point.negative,
	// 					ttBelow: point.ttBelow,
	// 					series: currentSeries,
	// 					h: anchor[2] || 0,
	// 				});
	// 			} else {
	// 				tooltip.hide();
	// 				return;
	// 			}
	// 		}
	// 		// Show it
	// 		if (tooltip.isHidden && tooltip.label) {
	// 			tooltip.label
	// 				.attr({
	// 					opacity: 1,
	// 				})
	// 				.show();
	// 		}
	// 		tooltip.isHidden = false;
	// 	}
	// 	utilities.fireEvent(this, "refresh");
	// };

	// our old refresh

		// 	Highcharts.Tooltip.prototype.refresh = function (pointOrPoints, mouseEvent) {
		// 		var tooltip = this,
		// 			label,
		// 			options =
		// 				tooltip.options,
		// 			x,
		// 			y,
		// 			point = pointOrPoints,
		// 			anchor,
		// 			textConfig = {},
		// 			pointConfig = [],
		// 			formatter = options.formatter || tooltip.defaultFormatter,
		// 			shared = tooltip.shared,
		// 			currentSeries;

		// 		if (!options.enabled) {
		// 			return;
		// 		}

		// 		clearTimeout(this.hideTimer);

		// 		// get the reference point coordinates (pie charts use tooltipPos)
		// 		tooltip.followPointer = Highcharts.splat(point)[0].series.tooltipOptions
		// 			.followPointer;
		// 		anchor = tooltip.getAnchor(point, mouseEvent);
		// 		x = anchor[0];
		// 		y = anchor[1];

		// 		// shared tooltip, array is sent over
		// 		if (shared && !(point.series && point.series.noSharedTooltip)) {
		// 			point.forEach(function (item) {
		// 				item.setState('hover');

		// 				pointConfig.push(item.getLabelConfig());
		// 			});

		// 			textConfig = {
		// 				x: point[0].category,
		// 				y: point[0].y
		// 			};
		// 			textConfig.points = pointConfig;
		// 			point = point[0];

		// 			// single point tooltip
		// 		} else {
		// 			console.log(point)
		// 			textConfig = point.getLabelConfig();
		// 		}
		// 		this.len = pointConfig.length; // #6128

		// 		var textPromise = formatter.call(textConfig, tooltip);

		// 		//the call might return plain text and not deferred object
		// 		//since we added deferred only to our callback.
		// 		//So we check if it is text and wrap it if needed
		// 		if (!textPromise.done) {
		// 			var text = textPromise;
		// 			textPromise = $.Deferred();
		// 			textPromise.resolve(text);
		// 		}

		// 		// register the current series
		// 		currentSeries = point.series;
		// 		this.distance = Highcharts.pick(currentSeries.tooltipOptions.distance, 16);

		// 		textPromise.done($.proxy(function (text) {
		// 			// update the inner HTML
		// 			if (text === false) {
		// 				this.hide();
		// 			} else {

		// 				label = tooltip.getLabel();

		// 				// show it
		// 				if (tooltip.isHidden) {
		// 					label.attr({
		// 						opacity: 1
		// 					}).show();
		// 				}

		// 				// update text
		// 				if (tooltip.split) {
		// 					this.renderSplit(text, splat(pointOrPoints));
		// 				} else {

		// 					// Prevent the tooltip from flowing over the chart box (#6659)

		// 					if (!options.style.width) {

		// 						label.css({
		// 							width: this.chart.spacingBox.width
		// 						});

		// 					}

		// 					label.attr({
		// 						text: text && text.join ? text.join('') : text
		// 					});

		// 					// Set the stroke color of the box to reflect the point
		// 					label.removeClass(/highcharts-color-[\d]+/g)
		// 						.addClass(
		// 							'highcharts-color-' +
		// 							Highcharts.pick(point.colorIndex, currentSeries.colorIndex)
		// 						);

		// 					label.attr({
		// 						stroke: (
		// 							options.borderColor ||
		// 							point.color ||
		// 							currentSeries.color ||
		// 							'#666666'
		// 						)
		// 					});

		// 					tooltip.updatePosition({
		// 						plotX: x,
		// 						plotY: y,
		// 						negative: point.negative,
		// 						ttBelow: point.ttBelow,
		// 						h: anchor[2] || 0
		// 					});
		// 				}

		// 				this.isHidden = false;
		// 			}
		// 		}, this));

		// 	}
	},
};
